<ng-container *ngIf='!accessDenied'>
    <div class="w-100 float-left">
        <div class="w-100 float-left v-align relative" *ngIf='mainPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">DIM-LEVEL-PERMISSION</h5>
                <div style="flex-grow: 1;"></div>
            </div>
        </div>
        <ngb-tabset type="pills" activeId='{{selectedTab}}' (tabChange)="beforeChange($event)">
            <ngb-tab title="Individual" id="individual">
                <ng-template ngbTabContent="ngbTabContent">
                    <div *ngIf='mainPage' class="main-table table-custom">
                        <div class="w-full pull-left no-padding-top pos-relative">
                            <div class="w-100 float-left p-3 light-bg">
                                <div class="w-100 float-left p-3 light-bg">
                                    <div class="form-group">
                                        <div class='col-lg-12 col-md-12 left-clear'>
                                            <label>
                                                <h5 class="medium m-0">Data Operations</h5>
                                            </label>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="!isProgress">
                                        <div class="form-group">
                                            <div class='col-lg-12 col-md-12 left-clear'>
                                                <form enctype="multipart/form-data" method="POST" class="">
                                                    <input type="file" accept=".xls,.xlsx"
                                                           class="pull-left next-btn r mt-smd m-r-smd m-b-smd"
                                                           multipart=true name="file" #file
                                                           (change)="fileChange($event)" placeholder="No File Chosen."/>
                                                    <button id="bulkUpload" type="submit"
                                                            class="btn btn-primary float-right mr-3"
                                                            (click)="bulkUpload($event)">Bulk Upload
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="isProgress">
                                        <div class="w-100 float-left p-3 light-bg">
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                     [ngStyle]="{'width':progress+ '%'}"
                                                     [attr.aria-valuenow]="progress" aria-valuemin="0"
                                                     aria-valuemax="100">{{progress}}%
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                                <div>
                                    <employeeFilter [displayTab]="'employeeSearch'"
                                                    (searchEmp)="showSearchFilter($event)"></employeeFilter>
                                </div>
                            </div>
                            <div class=" overflow-x pos-relative diff-table">
                                <div class="w-100 float-left mt-3">
                                    <div class="light-bg w-100 float-left p-2 grid-details">
                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"
                                             ngbTooltip="Employee Code">
                                            <h6 class="mb-lg-0 medium text-truncate"> Employee Code </h6>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"
                                             ngbTooltip="Employee Name">
                                            <h6 class="mb-lg-0 medium text-truncate"> Employee Name </h6>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"
                                             ngbTooltip="Select Employee">
                                            <h6 class="mb-lg-0 medium text-truncate">Select Employee</h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-100 float-left p-md-2 grid-details" *ngFor="let empData of employeeList">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"
                                         ngbTooltip="{{empData.empCode}}">
                                        <h6 class="mb-lg-0 medium text-truncate"> {{empData.empCode}} </h6>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"
                                         ngbTooltip="{{empData.displayName}}">
                                        <h6 class="mb-lg-0 medium text-truncate">
                                <span *ngIf="empData.displayName.length > 20">
                                    {{(empData.displayName | slice:0:20)+'..'}}
                                </span>
                                            <span *ngIf="empData.displayName.length <= 20">
                                    {{empData.displayName}}
                                </span>
                                        </h6>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left">
                                        <h6 class="mb-lg-0 medium">
                                            <!--<input type="radio" name="radio" (change)="change($event)" />-->
                                            <input type="radio" [id]="empData.id" [name]="one" [value]="empData.id"
                                                   (change)="onSelectEmployee($event)">
                                            <label [for]="empData.id">
                                            </label>
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <ng-container *ngIf="!(employeeList && employeeList.length)">
                                <div class="w-100 float-left  mt-3">
                                    <p class="text-center m-0 w-100 medium">No Results Found</p>
                                </div>
                            </ng-container>
                            <!-- PAGINATION -->
                            <div *ngIf="(employeeList && employeeList.length)"
                                 class="w-100 float-left my-4 light-bg p-3 align-v-center">
                                <h6 class="float-left mb-0 mr-4 text-truncate"> {{startingPage + 1}} - {{endingPage}}
                                    items of
                                    {{totalEmps}} </h6>
                                <div class="float-left ml-2 align-v-center">
                                    <label class="m-0 float-left">Show items per page</label>
                                    <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                                            (change)="OnPageSizeChanged($event)">
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                    </select>
                                </div>
                                <div style="flex-grow: 1;"></div>
                                <ngb-pagination [collectionSize]="totalEmps" [rotate]="true" [pageSize]="pageSize"
                                                [ellipses]="false"
                                                [maxSize]="5" [boundaryLinks]="true" [(page)]="currentPage"
                                                (pageChange)="onPageChange($event)"
                                                class="float-right"></ngb-pagination>
                            </div>
                            <div class="w-100 float-left">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pull-left form-group">
                                    <label for="Name">
                                        Dimension
                                        <span class="rq " style="color: red ">*</span>
                                    </label>
                                    <input auto-complete autocomplete="off" #dimAutoComplete class="form-control"
                                           name="orgTypeModel"
                                           [source]="searchDim.bind(this)" [value-formatter]="dimValueFormatter"
                                           [list-formatter]="dimListFormatter"
                                           placeholder="Select Dimension" class="form-control"
                                           (valueChanged)="onDimensionSelection($event)"
                                           [accept-user-input]="true" required>
                                    <!-- <select class="w-full pull-left form-control" (change)="onDimensionSelection($event) ">
                                    <option [attr.selected]="selectedDimension == 'selectOne' ? true : null" value="selectOne">Select One</option>
                                    <option *ngFor="let dims of dimList " [value]="dims.id ">{{dims.name}} ({{dims.dimCode}})</option>
                                </select> -->
                                    <ng-container *ngIf="selectedDimension != 'selectOne'">
                                        {{selectedDimension.name ? selectedDimension.name :
                                        selectedDimension.dimHierarchyLevelName
                                        ? selectedDimension.dimHierarchyLevelName : selectedDimension.dimName}}
                                        <!-- <span class="form-group" >&times;</span> -->
                                        <i class="fa fa-times" (click)="removeDimSelected()"></i>
                                    </ng-container>

                                </div>
                                <!-- <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pull-left form-group">
                                <label for="Name">
                                    Dimension Level
                                    <span class="rq " style="color: red ">*</span>
                                </label>
                                <select class="w-full pull-left form-control" (change)="onDimensionLevelSelect($event) ">
                                    <option value="selectOne">Select One</option>
                                    <option *ngFor="let levels of dimLevels" [value]="levels.id" [innerHTML]="levels.displayName "></option>
                                </select>
                            </div> -->

                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pull-left form-group">
                                    <label for="Name">
                                        Dimension Value
                                        <span class="rq " style="color: red ">*</span>
                                    </label>

                                    <input id='dimLvlVal' autocomplete="off" placeholder="Dimension Level Value "
                                           #autoCompletediv auto-complete [source]="getDimLvlVal.bind(this)"
                                           [list-formatter]="autoCompleteListFormatter"
                                           [value-formatter]="orgNameValueFormatter"
                                           (valueChanged)="onSelectDimLvlVal($event)"
                                           [accept-user-input]='true' class="flex-grow:1 drop-down form-control"
                                           type="text"/>
                                    <ng-container *ngIf="selecteDimensionValue">
                                        {{selecteDimensionValue.name}}
                                        <i class="fa fa-times" (click)="removeDimValue()"></i>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="w-100 float-left">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pull-left form-group">
                                    <label for="Name">
                                        Scope
                                        <span class="rq " style="color: red ">*</span>
                                    </label>
                                    <select class="w-full form-control" (change)="onScopeSelect($event) ">
                                        <option [disabled]='true' [attr.selected]="scope == undefined ? true : null"
                                                value="selectOne">Select
                                            One
                                        </option>
                                        <option *ngFor="let scope of scopeList" [value]="scope.id"> {{scope.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left  mt-3 form-group">
                                <button id="add" [disabled]="saveButton" class="btn btn-primary mr-3 float-right"
                                        (click)="onClickOfAdd()">Add
                                </button>
                            </div>
                            <div class="light-bg w-100 float-left p-2 grid-details" *ngIf="dimPermList.length>0">
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Dimension">
                                    <h6 class="mb-lg-0 medium text-truncate"> Dimension </h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                     ngbTooltip="Dimension Level">
                                    <h6 class="mb-lg-0 medium text-truncate">Dimension Level </h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                     ngbTooltip="Dimension Values">
                                    <h6 class="mb-lg-0 medium text-truncate">Dimension Values</h6>
                                </div>
                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="Scope">
                                    <h6 class="mb-lg-0 medium text-truncate">Scope</h6>
                                </div>
                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="Delete">
                                    <h6 class="mb-lg-0 medium text-truncate">Delete</h6>
                                </div>
                            </div>
                            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let orgData of dimPermList">
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                     ngbTooltip="{{orgData.dimName}}">
                                    <h6 class="mb-lg-0 medium text-truncate"> {{orgData.dimName}} </h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                     ngbTooltip="{{orgData.dimLvlName}}">
                                    <h6 class="mb-lg-0 medium text-truncate"> {{orgData.dimLvlName}} </h6>
                                </div>

                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                     ngbTooltip="{{orgData.dimLvlVal}}">
                                    <h6 class="mb-lg-0 medium text-truncate"> {{orgData.dimLvlVal}} </h6>
                                </div>

                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"
                                     ngbTooltip="{{orgData.scope}}">
                                    <h6 class="mb-lg-0 medium text-truncate"> {{orgData.scope}} </h6>
                                </div>

                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                                    <h6 class="mb-lg-0 medium">
                                        <!--<input type="radio" name="radio" (change)="change($event)" />-->

                                        <input type="checkbox" [id]="orgData.id" [name]="one" [value]="orgData.id"
                                               (change)="onSelectToDelete($event)">
                                        <label [for]="orgData.id">

                                        </label>

                                    </h6>
                                </div>
                            </div>
                            <!-- <div class="w-100 float-left p-md-2 grid-details">
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" *ngIf="dimPermList.length > 0">
                                    <button id="bulkUpload" type="submit" class="btn btn-primary float-right mr-3" (click)="deleteConfirm($event)">Delete Permissions</button>
                                </div>
                            </div> -->
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left mt-3"
                                 *ngIf="dimPermList.length > 0">
                                <button id="bulkUpload" type="submit" class="btn btn-primary float-right mr-3 p-2"
                                        (click)="deleteConfirm($event)">Delete
                                    Permissions
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ngb-tab>
            <ngb-tab title="Bulk" id="bulk">
                <ng-template ngbTabContent="ngbTabContent">
                    <div class="w-100 float-left mb-4 b-b">
                        <div class="row">
                            <div class="col-lg-8 col-md-8">
                                <div class="form-group align-v-center">
                                    <label class="medium col-4" for="excelTypeSelect">
                                        Browse File To Upload:
                                        <span class="text-danger medium">*</span>
                                    </label>
                                    <div class="relative">
                                        <input type="file" accept=".xlsx" class="fileInput" multipart=true name="file"
                                               #file (change)="chooseFile($event)" placeholder="No File Chosen."/>
                                        <button class="btn btn-primary ml-3">Browse</button>
                                    </div>
                                    <label class="mb-0 ml-2" *ngIf="fileNameToUpload != null">
                                        {{fileNameToUpload}}</label>
                                </div>
                                <ng-container *ngIf="fileNameToUpload != null">
                                    <div class="form-group w-100 float-left align-v-center">
                                        <label class="medium col-4" for="comments">
                                            Comments:
                                            <span class="text-danger medium">*</span>
                                        </label>
                                        <textarea class="form-control col-6 ml-3" rows="2"
                                                  name="comment" [(ngModel)]="comment" placeholder="Enter Comments"
                                                  required></textarea>
                                    </div>
                                    <div class="form-group w-100 float-left align-v-center">
                                        <label class="medium col-4"></label>
                                        <button id="bulkUpload" type="submit" class="btn btn-primary ml-3"
                                                (click)="initBulkUserDimRels($event)">
                                            Upload
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="form-group align-v-center">
                                    <a href='javascript:void(0)' class="" (click)="downloadTemplate()">Download
                                        Template</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-100 float-left mb-4" *ngIf="tableData.length > 0">
                        <div class="w-100 float-left align-v-center mb-3">
                            <div style="flex-grow: 1;"></div>
                            <button class="btn btn-primary float-right" name="userDimRelsHistoryRefresh"
                                    (click)="getUserDimRelsHistory()" [disabled]="uploadButtonDisable">
                                <i class="fa fa-refresh mr-2 text-white"></i> Refresh
                            </button>
                        </div>
                        <div class="col-lg-12 col-md-12 float-left">
                            <div class="light-bg w-100 p-2 grid-details">
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Comments</h6>
                                </div>
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Start Date</h6>
                                </div>
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Status</h6>
                                </div>
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Failure Reason</h6>
                                </div>
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Attached File</h6>
                                </div>
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Response File</h6>
                                </div>
                            </div>
                            <ng-container>
                                <div class="w-100 p-2 grid-details" *ngFor="let data of tableData">
                                    <div class="col-2">
                                        <h6 class="mb-0">{{data.comment}} </h6>
                                    </div>
                                    <div class="col-2">
                                        <h6 class="mb-0">{{data.startDate}}</h6>
                                    </div>
                                    <div class="col-2">
                                        <h6 class="mb-0">{{data.state}}</h6>
                                    </div>
                                    <div class="col-2">
                                        <h6 class="mb-0">{{data.failureReason}}</h6>
                                    </div>
                                    <div class="col-2">
                                        <a href="#/biAdmin/dimLvlPermissions" class="mb-0 small"
                                           *ngIf="data.attachedFiles.length > 0" ngbTooltip="{{'clickToDownload'}}"
                                           (click)="downloadUserDimRelsFiles(data.attachedFiles[0].filePath)">{{data.attachedFiles[0].name}}
                                        </a>
                                    </div>
                                    <div class="col-2">
                                        <a href="#/biAdmin/dimLvlPermissions" class="mb-0 small"
                                           *ngIf="data.attachedFiles.length > 1" ngbTooltip="{{'clickToDownload'}}"
                                           (click)="downloadUserDimRelsFiles(data.attachedFiles[1].filePath)">{{data.attachedFiles[1].name}}
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <!-- PAGINATION -->
                        <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
                            <h6 class="float-left mb-0 mr-4 text-truncate"> {{authStartingPage}} - {{authEndingPage}} of
                                {{authTotalRecs}}
                                items </h6>
                            <div class="float-left ml-2 align-v-center">
                                <label class="m-0 float-left">Show items per page</label>
                                <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="authPageSize"
                                        (change)="onAuthHistoryPageSizeChanged($event)">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                </select>
                            </div>
                            <div style="flex-grow: 1;"></div>
                            <ngb-pagination *ngIf='tableData && tableData.length' [collectionSize]="authTotalRecs"
                                            [rotate]="true"
                                            [maxSize]="5" [pageSize]="authPageSize" [ellipses]="false"
                                            [boundaryLinks]="true" [(page)]="authCurrentPage"
                                            (pageChange)="onAuthHistoryPageChange($event)"
                                            class="float-right"></ngb-pagination>
                        </div>
                    </div>
                </ng-template>
            </ngb-tab>
        </ngb-tabset>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dimLvlPermissions.component.html